import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setBreadCrumb } from "shared/redux/reducers/breadCrumbSlice";
import { findScreenTitle } from "shared/utils/helper";
import { Icons } from "assets";
import classNames from "classnames";
import BreadCrumb from "../../common/breadCrumb";
import styles from "./style.module.scss";

function MobileHeaderNestedPages() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const currentTitle = findScreenTitle(location.pathname);

    dispatch(
      setBreadCrumb({
        crumbs: [
          {
            title: currentTitle,
          },
        ],
        prePath: location.pathname,
      }),
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={classNames(styles.topLevelContainer)}>
      <div className={classNames("w-full relative", styles.headerContainer)}>
        <div
          className={classNames(styles.backButton, "flex items-center pt-1")}
          onClick={handleBack}
        >
          <Icons.ChevLeft />
          Back
        </div>
        <div className={classNames("absolute left-1/2 -translate-x-1/2 pt-1")}>
          <BreadCrumb />
        </div>
      </div>
    </div>
  );
}

export default MobileHeaderNestedPages;
